import axios from "axios";
import { TRANSFERS_QUERY_KEY, TRANSFERS_ACTIVITIES_QUERY_KEY } from "consts";
import { queryCache, useMutation } from "react-query";
import { ChangeAssignee } from "../types";

export const changeAssignee = async ({
  ids,
  assigneeId: userId,
}: ChangeAssignee) => {
  const { data } = await axios.post("transfers/assign", {
    transferId: ids[0],
    userId,
  });

  return data;
};

const useAssignTransfers = () =>
  useMutation(changeAssignee, {
    throwOnError: true,
    onSuccess: () => {
      queryCache.invalidateQueries(TRANSFERS_QUERY_KEY);
      queryCache.invalidateQueries(TRANSFERS_ACTIVITIES_QUERY_KEY);
    },
  });

export default useAssignTransfers;
